"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _roundTo = _interopRequireDefault(require("../../utils/roundTo"));

var _integerFilter = _interopRequireDefault(require("./integerFilter"));

var _decimalFilter = _interopRequireDefault(require("./decimalFilter"));

var _getBoundedValue = _interopRequireDefault(require("../../utils/numbers/getBoundedValue"));

var _componentMap = _interopRequireDefault(require("./componentMap"));

var _inputMode = _interopRequireDefault(require("./inputMode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getValueString = function getValueString(value) {
  return typeof value === 'undefined' || value === null ? '' : value.toString();
};

var NumberInput = function NumberInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur,
      type = _ref.type,
      step = _ref.step,
      min = _ref.min,
      max = _ref.max,
      unit = _ref.unit,
      rest = _objectWithoutPropertiesLoose(_ref, ["value", "onChange", "onFocus", "onBlur", "type", "step", "min", "max", "unit"]);

  var inputFilter = type === 'decimal' ? _decimalFilter.default : _integerFilter.default;
  var rounder = step ? (0, _roundTo.default)(step, min < 0) : function (anyValue) {
    return anyValue;
  };

  var isInStep = function isInStep(testNumber) {
    return rounder(testNumber) === testNumber;
  };

  var _useState = (0, _react.useState)(getValueString(value).toString()),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  (0, _react.useEffect)(function () {
    // keep internal value in sync with prop change
    setInternalValue(getValueString(value));
  }, [value]);

  var _useState2 = (0, _react.useState)(false),
      hasFocus = _useState2[0],
      setFocus = _useState2[1];

  var onChangeHandler = function onChangeHandler(newValue) {
    var filteredValue = inputFilter(newValue);
    setInternalValue(filteredValue);

    if (newValue === '') {
      onChange(null);
      return;
    }

    var valueAsNumber = type === 'integer' ? parseInt(filteredValue, 10) : parseFloat(filteredValue);

    if (valueAsNumber.toString() === newValue && valueAsNumber >= min && valueAsNumber <= max && isInStep(valueAsNumber)) {
      onChange(valueAsNumber);
    }
  };

  var incrementHandler = function incrementHandler(increment) {
    var currentValue = type === 'integer' ? parseInt(internalValue, 10) : parseFloat(internalValue); // if current value is out of step, first increment should just fix that

    var amountToIncrement = isInStep(currentValue) ? increment : increment / 2;
    onChangeHandler((0, _getBoundedValue.default)(rounder(currentValue + amountToIncrement), min, max).toString());
  };

  var blurHandler = function blurHandler() {
    // tries to apply current value, or the nearest valid number
    var currentValue = type === 'integer' ? parseInt(internalValue, 10) : parseFloat(internalValue);
    onChangeHandler((0, _getBoundedValue.default)(rounder(currentValue), min, max).toString());
  };

  var InputComponent = (0, _componentMap.default)({
    unit: unit
  });
  return _react.default.createElement(InputComponent, _extends({
    unit: unit,
    type: "text",
    inputMode: (0, _inputMode.default)(type, min),
    value: hasFocus ? internalValue : getValueString(value),
    onFocus: function onFocus(e) {
      setFocus(true);

      if (_onFocus) {
        _onFocus(e);
      }
    },
    onBlur: function onBlur(e) {
      setFocus(false);

      if (internalValue !== getValueString(value)) {
        blurHandler();
      }

      if (_onBlur) {
        _onBlur(e);
      }
    },
    onChange: function onChange(_ref2) {
      var newValue = _ref2.target.value;
      return onChangeHandler(newValue);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === '-' && e.target.selectionStart !== 0) {
        // mask out any negative signs not at start
        e.preventDefault();
      }

      if (e.key === 'Enter') {
        // catch form submits using enter key and make sure we fire the blur handler
        if (internalValue !== getValueString(value)) {
          blurHandler();
        }
      }

      if (e.keyCode === 38) {
        // up arrow
        incrementHandler(step || 1);
      }

      if (e.keyCode === 40) {
        // down arrow
        incrementHandler(-(step || 1));
      }
    }
  }, rest));
};

NumberInput.propTypes = {
  value: _propTypes.number,
  min: _propTypes.number,
  max: _propTypes.number,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,
  onBlur: _propTypes.func,
  type: (0, _propTypes.oneOf)(['integer', 'decimal']),
  step: _propTypes.number,
  unit: _propTypes.string
};
NumberInput.defaultProps = {
  value: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  min: 0,
  max: Number.MAX_SAFE_INTEGER,
  // IE fill
  type: 'integer',
  step: undefined,
  unit: undefined
};
var _default = NumberInput;
exports.default = _default;